const { logger } = require('../logging')

/**
 * Returns boolean if the country is enabled
 * @param {*} countryListConfig  Based on the FEATURE_SUBSCRIPTION_V2_COUNTRIES  config (list of countryCodes `,` separated )
 * @param {*} countryCode
 */
const featureToggleSubscription = (countryListConfig = '', countryCode = '') => {
  const enabledCountries = countryListConfig.toUpperCase().split(',').filter(Boolean)

  if (enabledCountries.includes('ALL')) {
    logger.info('It`s time to remove this feature toggle `featureToggleSubscription`')
    return true
  }
  return enabledCountries.includes(countryCode.toUpperCase())
}

module.exports = featureToggleSubscription
